module.exports = __webpack_public_path__ + "img/oppo-wh.9aa223ba.svg";